export enum ConfigurationType {
  TEMPLATE = 'template',
  ATTACHMENTS = 'Attachments',

  USERS = 'users',
}
